import { useEffect, useState } from "react";
import { ScanLine } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ScanItem } from "@/components/scan/ScanItem";
import { ScanWizard } from "@/components/scan/ScanWizard";
import { Button } from "@/components/ui/button";

export const LinkedDocuments = ({ customerId, portfolioId }) => {
  const { hasFeature } = useAuth();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const enabled = hasFeature("SCAN");
  const params = customerId ? { customer_id: customerId } : { portfolio_id: portfolioId };
  const load = () => api.get("/scans", { params }).then((r) => setItems(r.data));
  useEffect(() => { if (enabled) load(); }, [customerId, portfolioId, enabled]);
  if (!enabled) return null;

  return (
    <div className="space-y-2" data-testid="linked-documents">
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Belgeler ({items.length})</div>
        <Button size="sm" variant="outline" data-testid="linked-scan-btn" onClick={() => setOpen(true)}><ScanLine className="w-4 h-4 mr-1" />Belge tara</Button>
      </div>
      {items.length === 0 ? <div className="text-sm text-slate-500 rounded-lg bg-slate-50 p-4 text-center">İlişkilendirilmiş belge yok</div>
        : <div className="grid md:grid-cols-2 gap-2">{items.map((s) => <ScanItem key={s.id} s={s} onChanged={load} />)}</div>}
      <ScanWizard open={open} onClose={() => setOpen(false)} onSaved={load} preset={params} />
    </div>
  );
};
